import SchemaMarkupTextField from '../SchemaMarkupTextField/SchemaMarkupTextField.vue'
import SchemaMarkupNumber from '../SchemaMarkupNumber/SchemaMarkupNumber.vue'
import SchemaMarkupCheckbox from '../SchemaMarkupCheckbox/SchemaMarkupCheckbox.vue'
import SchemaMarkupDate from '../SchemaMarkupDate/SchemaMarkupDate.vue'
import SchemaMarkupDropdown from '../SchemaMarkupDropdown/SchemaMarkupDropdown.vue'

export default {
    name: "SchemaLeaf",

    components: {
        SchemaMarkupTextField,
        SchemaMarkupNumber,
        SchemaMarkupCheckbox,
        SchemaMarkupDate,
        SchemaMarkupDropdown
    },

    props: {
        field: {
            type: Object,
            required: true
        }
    }
}
